import { useContext, useEffect, useState } from "react"
import BaseButtonRow from "../../../components/elements/BaseButtonRow"
import BaseGrowBody from "../../../components/elements/BaseGrowBody"
import BaseHeadBanner from "../../../components/elements/BaseHeadBanner"
import BasePage from "../../../components/layout/BasePage"
import { deleteReport, getSingleReport } from "../api/apiCalls"
import { useQuery, useQueryClient } from "@tanstack/react-query"
import { useParams } from "react-router-dom"
import { useUpdateReportMutation, useToggleReportArchiveMutation } from "../api/services"
import BaseButton from "../../../components/elements/BaseButton"
import { ReactComponent as ARCHIVE } from "../../../assets/ArchiveICON.svg"
import { ReactComponent as UNARCHIVE } from "../../../assets/UnArchiveICON.svg"
import ErrorPage from "../../404/ErrorPage"
import Loading from "../../../components/common/Loading"
import { GeneralQueryKeys } from "../../../api/constants"
import ReportDetailInformation from "../components/ReportDetailInformation"
import dayjs from "dayjs"
import { Form } from "antd"
import { Euro, Trash } from "lucide-react"
import { useDownloadDocumentMutation } from "../../api/services"
import { ObjectOnlyAddressType } from "../../Objekte/types/types"
import BillFromElementModal from "../../Buchhaltung/components/billFromElement/BillFromElementModal"
import { ModalContext } from "../../../components/contexts/ModalContext"
import { transformReportMaterialsAndInformationToBillPositions } from "../../../services/functions"
import { PositionData } from "../../../data/Types"

export default function ReportDetailPage() {
    const { id } = useParams()
    const modalCon = useContext(ModalContext)
    // GET single report
    const queryKeySingleReport = GeneralQueryKeys.REPORT_SINGLE + id
    const {
        error: singleReportError,
        isLoading: singleReportIsLoading,
        data: singleReportData,
    } = useQuery({
        queryKey: [queryKeySingleReport],
        queryFn: () => getSingleReport(id ?? ""),
        enabled: !!id,
    })

    const handleSetForm = () => {
        console.log(singleReportData?.materials)
        form.setFieldsValue({
            date: dayjs(singleReportData?.date).format("YYYY-MM-DD"),
            objectId:
                typeof singleReportData?.objectId === "string"
                    ? singleReportData?.objectId
                    : `${singleReportData?.objectId.adress?.street} ${singleReportData?.objectId.adress?.nr}, ${singleReportData?.objectId.adress?.plz} ${singleReportData?.objectId.adress?.city}`,
            materialsCount: singleReportData?.materials.length,
            documentsCount: singleReportData?.documents.length,
            createdAt: dayjs(singleReportData?.createdAt).format("DD.MM.YYYY, HH:mm"),
            updatedAt: dayjs(singleReportData?.updatedAt).format("DD.MM.YYYY, HH:mm"),
            information: singleReportData?.information,
            materials: singleReportData?.materials || [],
        })
    }

    // UPDATE
    const queryClient = useQueryClient()
    const { mutate: updateReport } = useUpdateReportMutation(queryClient, queryKeySingleReport)
    const handleUpdateReport = () => {
        console.log(form.getFieldsValue())
        updateReport({
            id: id ?? "",
            body: form.getFieldsValue(),
        })
        setIsEditing(false)
    }

    const [form] = Form.useForm()
    const [isEditing, setIsEditing] = useState(false)
    useEffect(() => {
        if (singleReportData) {
            handleSetForm()
        }
    }, [singleReportData, form])

    // download file from task
    const { mutate: downloadFile } = useDownloadDocumentMutation()
    const handleDownload = (s3Key: string, filename: string) => {
        downloadFile({ id: id ?? "", s3Key: s3Key, filetype: "report", filename: filename })
    }

    const { mutate: toggleArchive } = useToggleReportArchiveMutation(queryClient, queryKeySingleReport)
    // TOGGLE Archive
    if (!singleReportData) return null
    if (singleReportError) return <ErrorPage />
    if (singleReportIsLoading) return <Loading />

    return (
        <BasePage>
            <BaseHeadBanner title={"Bericht"} />
            <BaseButtonRow justifyEnd>
                <BaseButton
                    label={singleReportData?.archived ? "Entarchivieren" : "Archivieren"}
                    func={() => toggleArchive(singleReportData?._id ?? "")}
                    icon={singleReportData?.archived ? <UNARCHIVE className="w-6 h-6" /> : <ARCHIVE className="w-6 h-6" />}
                />
                {/* <BaseButton
                    label={"Dokumente hinzufügen"}
                    func={() => deleteReport(singleReportData?._id ?? "")}
                    icon={<FilePlus className="w-6 h-6" />} /> */}
                <BaseButton label={"Rechnung erstellen"} func={() => modalCon?.trigger(0)} icon={<Euro className="w-6 h-6" />} />
                <BaseButton label={"Löschen"} func={() => deleteReport(singleReportData?._id ?? "")} icon={<Trash className="w-6 h-6" />} />
            </BaseButtonRow>
            <Form form={form} onFinish={handleUpdateReport} disabled={!isEditing} className="grow">
                <BaseGrowBody classProps="flex flex-row gap-4 w-full h-full">
                    <ReportDetailInformation
                        displayedReport={singleReportData}
                        isEditing={isEditing}
                        handleDownload={handleDownload}
                        handleCancel={() => {
                            setIsEditing(false)
                            handleSetForm()
                        }}
                        handleEdit={() => setIsEditing(true)}
                        setIsEditing={setIsEditing}
                        form={form}
                    />
                </BaseGrowBody>
            </Form>
            <BillFromElementModal
                id={singleReportData?._id ?? id ?? ""}
                type="report"
                modalId={0}
                queryKey={queryKeySingleReport}
                billData={{
                    customer_id: singleReportData?.customer?._id ?? "",
                    customer_name: singleReportData?.customer?.name ?? "",
                    object_id: singleReportData?.objectId as unknown as ObjectOnlyAddressType,
                    positions: transformReportMaterialsAndInformationToBillPositions(singleReportData?.materials ?? [], singleReportData?.information ?? "") as PositionData[],
                }}
                documents={singleReportData?.documents ?? []}
            />
        </BasePage>
    )
}
